import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import validator from 'validator';
import { useAuth } from '../../providers/auth_provider';
import { useNavigate } from 'react-router-dom'; 

export default function Login() {
    const { login } = useAuth();
    const [identifier, setIdentifier] = useState('');
    const [password, setPassword] = useState('');
    const [rememberMe, setRememberMe] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errors, setErrors] = useState({ identifier: '', password: '' });
    const navigate = useNavigate();
    const validateFields = () => {
        const newErrors = { identifier: '', password: '' };
        let isValid = true;

        if (!validator.isEmail(identifier) && !validator.isMobilePhone(identifier)) {
            newErrors.identifier = 'Invalid email or phone number';
            isValid = false;
        }

        if (validator.isEmpty(password)) {
            newErrors.password = 'Password is required';
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        if (!validateFields()) return;
        setIsSubmitting(true);
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/admin/login`, {
                identifier,
                password,
                remember_me: rememberMe,
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    Signature: `${process.env.REACT_APP_API_SIGNATURE}`,
                },
            });
            const { user, token } = response.data;
            login(token, rememberMe);
            toast.success(`Welcome back, ${user.first_name} ${user.last_name}!`);
            navigate('/');
        } catch (error) {
            toast.error(error.response.data.message || 'Login failed. Please check your credentials.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="position-relative">
            <div className="authentication-wrapper authentication-basic container-p-y p-4 p-sm-0">
                <div className="authentication-inner py-6">
                    {/* Login */}
                    <div className="card p-md-7 p-1">
                        {/* Logo */}
                        <div className="app-brand justify-content-center mt-5">
                            <a href="index.html" className="app-brand-link gap-2">
                                <span className="app-brand-logo demo">
                                    <span style={{ color: "#666cff" }}>
                                        <img src="/assets/img/logo.png" alt="" />
                                    </span>
                                </span>
                            </a>
                        </div>
                        {/* /Logo */}
                        <div className="card-body mt-1">
                            <h4 className="mb-1">Welcome Back! 👋</h4>
                            <p className="mb-5">
                                Please sign-in to your account and start the adventure
                            </p>
                            <form id="formAuthentication" className="mb-5" onSubmit={handleLogin}>
                                <div className="form-floating form-floating-outline mb-5">
                                    <input
                                        type="text"
                                        className={`form-control ${errors.identifier ? 'is-invalid' : ''}`}
                                        id="identifier"
                                        name="email-phone"
                                        placeholder="Enter your email or phone"
                                        value={identifier}
                                        onChange={(e) => setIdentifier(e.target.value)}
                                    />
                                    <label htmlFor="identifier">Email or Phone</label>
                                    <div className="invalid-feedback">
                                        {errors.identifier}
                                    </div>
                                </div>
                                <div className="mb-5">
                                    <div className="form-password-toggle">
                                        <div className="input-group input-group-merge">
                                            <div className="form-floating form-floating-outline">
                                                <input
                                                    type={showPassword ? 'text' : 'password'}
                                                    id="password"
                                                    className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                                                    name="password"
                                                    placeholder="············"
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                />
                                                <label htmlFor="password">Password</label>
                                            </div>
                                            <span
                                                className="input-group-text cursor-pointer"
                                                onClick={() => setShowPassword(!showPassword)}
                                            >
                                                <i className={showPassword ? "ri-eye-fill" : "ri-eye-off-line"} />
                                            </span>
                                        </div>
                                    </div>
                                    <div className="invalid-feedback">
                                        {errors.password}
                                    </div>
                                </div>
                                <div className="mb-5 d-flex justify-content-between mt-5">
                                    <div className="form-check mt-2">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="remember-me"
                                            checked={rememberMe}
                                            onChange={(e) => setRememberMe(e.target.checked)}
                                        />
                                        <label className="form-check-label" htmlFor="remember-me">
                                            Remember Me
                                        </label>
                                    </div>
                                    {/* <a
                                        href="auth-forgot-password-basic.html"
                                        className="float-end mb-1 mt-2"
                                    >
                                        <span>Forgot Password?</span>
                                    </a> */}
                                </div>
                                <div className="mb-5">
                                    <button
                                        className="btn btn-primary d-grid w-100"
                                        type="submit"
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? (
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        ) : (
                                            'Sign in'
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                    {/* /Login */}
                    <img
                        alt="mask"
                        src="/assets/img/illustrations/auth-basic-login-mask-light.png"
                        className="authentication-image d-none d-lg-block"
                        data-app-light-img="illustrations/auth-basic-login-mask-light.png"
                        data-app-dark-img="illustrations/auth-basic-login-mask-dark.html"
                    />
                </div>
            </div>
        </div>
    );
}
